module.exports = __webpack_public_path__ + "img/music.4bf6d9f0.png";